import { Action } from '@ngrx/store';
import { EntriesState } from '../../../../../../core/features/store/base-feature-state';
import { News } from '../../model';
import { NewsActions } from '../actions';
import { NewsActionTypes } from '../actions/news.action';

export const initialState: EntriesState<News> = {};

export function reducer(state = initialState, action: Action): EntriesState<News> {
  switch (action.type) {
    case NewsActionTypes.LoadNewsSuccess: {
      const _action = <NewsActions.LoadNewsSuccess>action;
      const payload: News[] = _action.payload;
      return payload.reduce(
        (entities: { [id: number]: News }, news: News) => {
          return {
            ...entities,
            [news.id]: news,
          };
        },
        {
          ...state,
        }
      );
    }
    default:
      return state;
  }
}
